import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, deleteDoc, updateDoc, addDoc } from 'firebase/firestore'; // Ajout de updateDoc pour la modification
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus ,faTrash } from '@fortawesome/free-solid-svg-icons';
import EditAddonModal from './EditAddonModal'; // Importer la modale d'édition
import CreateAddonModal from './CreateAddonModal';
import ReactPaginate from 'react-paginate';
import { Modal, Button } from 'react-bootstrap';
import { UserContext } from '../../../contexts/UserContext';

const Addons = () => {
    const [addons, setAddons] = useState([]);
    const [filterName, setFilterName] = useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedAddon, setSelectedAddon] = useState(null); // Pour stocker l'addon sélectionné pour l'édition
    const { user } = useContext(UserContext);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [addonToDelete, setAddonToDelete] = useState(null);

    const addonsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        const fetchAddons = async () => {
            try {
                const addonsCollection = collection(db, 'addons');
                const addonsSnapshot = await getDocs(addonsCollection);
                const addonsList = addonsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setAddons(addonsList);
            } catch (error) {
                console.error("Error fetching addons: ", error);
            }
        };
        fetchAddons();
    }, []);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleDeleteAddon = async (addonId) => {
        try {
            const addonDoc = doc(db, 'addons', addonId);
            await deleteDoc(addonDoc);
            setAddons(addons.filter(addon => addon.id !== addonId));
        } catch (error) {
            console.error("Erreur lors de la suppression de l'addon: ", error);
        }
    };

    const handleShowConfirmModal = (addonId) => {
        setAddonToDelete(addonId);
        setShowConfirmModal(true);
    };

    const handleCloseConfirmModal = () => setShowConfirmModal(false);

    const handleConfirmDelete = () => {
        handleDeleteAddon(addonToDelete);
        setShowConfirmModal(false);
    };

    const handleEditAddon = (addon) => {
        setSelectedAddon(addon);
        setShowEditModal(true);
    };

    const handleUpdateAddon = async (updatedAddon) => {
        try {
            const addonDoc = doc(db, 'addons', updatedAddon.id);
            await updateDoc(addonDoc, updatedAddon); // Mettre à jour l'addon dans Firestore
            setAddons(addons.map(addon => (addon.id === updatedAddon.id ? updatedAddon : addon)));
            setShowEditModal(false);
        } catch (error) {
            console.error("Erreur lors de la modification de l'addon: ", error);
        }
    };

    const filteredAddons = addons.filter(addon => addon.nom.toLowerCase().includes(filterName.toLowerCase()));
    const indexOfLastAddon = (currentPage + 1) * addonsPerPage;
    const indexOfFirstAddon = indexOfLastAddon - addonsPerPage;
    const currentAddons = filteredAddons.slice(indexOfFirstAddon, indexOfLastAddon);
    const pageCount = Math.ceil(filteredAddons.length / addonsPerPage);

    return (
        <div id="content-wrapper" className="d-flex flex-column ">
            <div id="content">
                <div className="container-fluid">
                    <button className="btn btn-red2 mb-4" onClick={() => setShowCreateModal(true)} style={{ cursor: 'pointer' }}>
                        <FontAwesomeIcon icon={faPlus} /> Ajouter un addon
                    </button>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2">Modules supplémentaires </h6>
                            <input
                                type="text"
                                className="form-control w-25"
                                placeholder="Filtrer par nom"
                                value={filterName}
                                onChange={(e) => setFilterName(e.target.value)}
                            />
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Modules</th>
                                            {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && <th>Action</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentAddons.map((addon) => (
                                            <tr key={addon.id}>
                                                <td>{addon.nom}</td>
                                                <td>{addon.modules.map((module) => <p>{module.nom} - {module.prix}€</p>)}</td>
                                                {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                    <>
                                                        <Link
                                                            className=" btn-primary btn-circle btn-sm ml-2"
                                                            onClick={() => handleEditAddon(addon)}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </Link>
                                                        <Link 
                                                            className=" btn-danger btn-circle btn-sm ml-2" 
                                                            onClick={() => handleShowConfirmModal(addon.id)}>
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </Link>
                                                    </>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-start'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modale de confirmation à l'intérieur du composant Addons */}
            <Modal show={showConfirmModal} onHide={handleCloseConfirmModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>Êtes-vous sûr de vouloir supprimer cet addon ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirmModal}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modale de création d'addon */}
            <CreateAddonModal 
                show={showCreateModal} 
                handleClose={() => setShowCreateModal(false)} 
                handleCreate={async (newAddon) => {
                    try {
                        const docRef = await addDoc(collection(db, 'addons'), newAddon);
                        setAddons([...addons, { id: docRef.id, ...newAddon }]); // Ajouter l'addon à la liste
                    } catch (error) {
                        console.error("Erreur lors de l'ajout de l'addon: ", error);
                    }
                    setShowCreateModal(false); // Fermer la modale après l'ajout
                }} 
            />

            {/* Modale d'édition d'addon */}
            {selectedAddon && (
                <EditAddonModal 
                    show={showEditModal} 
                    handleClose={() => setShowEditModal(false)} 
                    addon={selectedAddon} 
                    handleUpdate={handleUpdateAddon} 
                />
            )}
        </div>
    );
};

export default Addons;
